export default __webpack_public_path__ + "static/media/Isometric_Square_orange.0c42b84e.svg";